document.addEventListener('DOMContentLoaded', function () {
  // === VARIANT MAP: Add-on selection → Shopify variant ID ===
  // Product: Pineapple Bliss Preorder (ID: 9615911092455)
  const VARIANT_MAP = {
    none:   52266950721767,  // Jar Only — $18
    juice1: 52266950754535,  // + 1 Cold Pressed Juice — $28
    juice2: 52266950787303,  // + 2 Cold Pressed Juices — $36
    shot:   52266950820071,  // + Wellness Shot — $23
  };

  const BASE_PRICE = 18;
  const ADD_ON_PRICES = { none: 0, juice1: 10, juice2: 18, shot: 5 };
  const ADDON_LABELS  = { none: 'No add-on', juice1: '+1 Cold Pressed Juice', juice2: '+2 Cold Pressed Juices', shot: '+Wellness Shot' };

  // === DOM refs (using actual IDs from the page) ===
  const qtyBtns    = document.querySelectorAll('.oj-qty-btn');  // [0]=minus, [1]=plus
  const qtyDisplay = document.getElementById('ojQtyNum');
  const totalEl    = document.getElementById('ojTotalAmt');
  const submitBtn  = document.querySelector('.oj-submit');
  const successEl  = document.getElementById('ojSuccess');
  const addOnCheckboxes = document.querySelectorAll('.oj-addon-check');

  // Form fields by ID
  const nameEl   = document.getElementById('oj-name');
  const phoneEl  = document.getElementById('oj-phone');
  const igEl     = document.getElementById('oj-ig');
  const pickupEl = document.getElementById('oj-pickup');

  // Addon checkbox order: [0]=+1 juice, [1]=+2 juices, [2]=wellness shot
  const ADDON_KEYS = ['juice1', 'juice2', 'shot'];

  let qty = 1;

  function getSelectedAddOn() {
    let selected = 'none';
    addOnCheckboxes.forEach(function(cb, i) {
      if (cb.checked && ADDON_KEYS[i]) {
        var key = ADDON_KEYS[i];
        if (ADD_ON_PRICES[key] > ADD_ON_PRICES[selected]) selected = key;
      }
    });
    return selected;
  }

  function updateTotal() {
    var addOn = getSelectedAddOn();
    var total = (BASE_PRICE + ADD_ON_PRICES[addOn]) * qty;
    if (totalEl) totalEl.textContent = '$' + total.toFixed(2);
  }

  // Qty stepper
  if (qtyBtns[0]) {
    qtyBtns[0].addEventListener('click', function () {
      if (qty > 1) { qty--; if (qtyDisplay) qtyDisplay.textContent = qty; updateTotal(); }
    });
  }
  if (qtyBtns[1]) {
    qtyBtns[1].addEventListener('click', function () {
      qty++; if (qtyDisplay) qtyDisplay.textContent = qty; updateTotal();
    });
  }
  addOnCheckboxes.forEach(function(cb) { cb.addEventListener('change', updateTotal); });

  // Reserve button
  if (submitBtn) {
    submitBtn.addEventListener('click', function (e) {
      e.preventDefault();

      var name   = nameEl?.value?.trim();
      var phone  = phoneEl?.value?.trim();
      var ig     = igEl?.value?.trim() || '';
      var pickup = pickupEl?.value;

      if (!name)  { alert('Please enter your name.'); nameEl?.focus(); return; }
      if (!phone) { alert('Please enter your phone number.'); phoneEl?.focus(); return; }
      if (!pickup || pickup === '') { alert('Please select a pickup location.'); pickupEl?.focus(); return; }

      var addOn     = getSelectedAddOn();
      var variantId = VARIANT_MAP[addOn];
      var cartNote  = [
        'Name: ' + name,
        'Phone: ' + phone,
        'Instagram: ' + (ig || 'N/A'),
        'Pickup: ' + pickup,
        'Add-on: ' + ADDON_LABELS[addOn],
        'Qty: ' + qty
      ].join(' | ');

      submitBtn.textContent = 'Reserving... 🍍';
      submitBtn.disabled = true;

      // Clear cart → add preorder item → set note → go to checkout
      fetch('/cart/clear.js', { method: 'POST', headers: { 'Content-Type': 'application/json' } })
        .then(function() {
          return fetch('/cart/add.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ id: variantId, quantity: qty })
          });
        })
        .then(function(r) { return r.json(); })
        .then(function() {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ note: cartNote })
          });
        })
        .then(function() {
          // Redirect to Shopify checkout — customer pays & gets confirmation
          window.location.href = '/checkout';
        })
        .catch(function(err) {
          console.error('OJ Preorder error:', err);
          submitBtn.textContent = 'Reserve My Jar 🍍';
          submitBtn.disabled = false;
          alert('Something went wrong. Please try again or DM us @organicjusu');
        });
    });
  }

  updateTotal();
});